function getActiveInactiveStatus(status) {
  switch (status) {
    case 'ACTIVE':
      return 'Active';
    case 'INACTIVE':
      return 'In-Active';
    default:
      return 'Unknown';
  }
}

export default getActiveInactiveStatus;
